export const AVAILABILITY_DATE_TRIGGER_SELECTOR =
  '[data-availability-date-trigger]';

const isElementVisible = (element: HTMLElement) => {
  let el: HTMLElement | null = element;

  while (el) {
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') {
      return false;
    }
    el = el.parentElement;
  }

  return true;
};

/** Opens the visible availability date-range popover (desktop or mobile). */
export const openAvailabilityDatePicker = () => {
  const triggers = document.querySelectorAll<HTMLElement>(
    AVAILABILITY_DATE_TRIGGER_SELECTOR
  );

  const visibleTrigger = Array.from(triggers).find(isElementVisible);
  if (visibleTrigger) {
    visibleTrigger.click();
  }
};
